// Reducers take state and an action as parameters and return new state
// We combine reducers and pass them as a parameter to the redux store

import { combineReducers } from 'redux';

import loginReducer from './loginReducer';
import accountReducer from './accountReducer';
import studyReducer from './studyReducer';
import definitionReducer from './definitionReducer';
import dictionaryReducer from './dictionaryReducer';
import crosstabReducer from './crosstabReducer';
import quickReportsReducer from './quickReportsReducer';
import userDetailReducer from './userDetailReducer';
import adminReducer from './adminReducer';
import datahaulReducer from './datahaulReducer';
// import storyboardReducer from './storyboardReducer';
import insight360Reducer from './insight360Reducer';
import geographiesReducer from './geographyReducer';
import dataPointReducer from './dataPointReducer';
import qtsReducer from './qtsReducer';
import salesCatalystReducer from './salesCatalystReducer';
import baseReducer from './baseReducer';
import preferencesReducer from './preferencesReducer';
import supportReducers from './supportReducers';
import geomapReducer from './geomapReducer';
import mmeReducer from './mmeReducer';
import turnkeyOmnibusReducer from './turnkeyOmnibusReducer';
import cacReducer from './cacReducer';
import { deImportDefReducer } from './deReducer/deImportDefReducer';
import { deTargetDashboardReducer } from './deReducer/deTargetDashboardReducer';
import { deLabelReducer } from './deReducer/deLabelReducer';
import { deBuildReducer } from './deReducer/deBuildReducer';
import contractAdminReducer from './contractAdminReducer';
import { deDistributeReducer } from './deReducer/deDistributeReducer';
import rldToolReducer from './rldToolReducer/rldToolReducer';

const appReducer = combineReducers({
  login: loginReducer,
  account: accountReducer,
  study: studyReducer,
  definition: definitionReducer,
  dictionary: dictionaryReducer,
  crosstab: crosstabReducer,
  quickReports: quickReportsReducer,
  userDetail: userDetailReducer,
  admin: adminReducer,
  datahaul: datahaulReducer,
  // storyboard: storyboardReducer,
  insight360: insight360Reducer,
  geographies: geographiesReducer,
  qts: qtsReducer,
  dataPointsAlreadyAdded: dataPointReducer,
  salesCatalyst: salesCatalystReducer,
  selectedBase: baseReducer,
  preferences: preferencesReducer,
  support: supportReducers,
  geomap: geomapReducer,
  mme: mmeReducer,
  turnkeyOmnibus: turnkeyOmnibusReducer,
  correspondenceCluster: cacReducer,
  deImportDefiniton: deImportDefReducer,
  deTargetDashboard: deTargetDashboardReducer,
  deLabel: deLabelReducer,
  deBuild: deBuildReducer,
  contractAdmin: contractAdminReducer,
  deDistribute: deDistributeReducer,
  rldTool: rldToolReducer,
});

const rootReducer = (state, action) => appReducer(state, action);

export default rootReducer;
